// extracted by mini-css-extract-plugin
export default {"wrapper":"error_wrapper__m8QsG","content":"error_content__NZAdC","error_text":"error_error_text__15v9A","title":"error_title__7A5e-"};